import Icon, {IconWithTrackEvent} from './Icon';
export default Icon;
export {
  IconWithTrackEvent,
};
